<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="show"
      :before-close="handleClose"
      append-to-body
      width="1000px"
    >
      <div class="dialog-common-xb">
        <div
          class="col-lg-12 list-header pad-header-bg clearfix"
          id="div-resize"
          style="background-color: white; padding: 10px 0; margin-top: -10px"
        >
          <div class="app-list-sort header-item-fix">
            <b-dropdown>
              <template v-slot:button-content>
                <sort-icon />
              </template>
              <b-dropdown-item
                v-for="(item, index) in sortList"
                :kedark="index"
                @click="listSort(item)"
                :key="index"
              >
                <span class="pull-left" v-if="pageParams.orderBy == item.value">
                  <i
                    v-if="pageParams.sort == 'desc'"
                    class="bx bx-down-arrow-alt font-size-18 pull-left"
                  ></i>
                  <i
                    v-if="pageParams.sort == 'asc'"
                    class="bx bx-up-arrow-alt font-size-18"
                  ></i>
                </span>
                <span :class="{ padleft: pageParams.orderBy != item.value }">{{
                  item.text
                }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="header-item-fix" style="margin: 0px">
            <!-- <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.creator"
              placeholder="搜索发稿人"
              @keyup.enter.native="search"
            ></b-form-input> -->
            <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.contentKeyword"
              placeholder="用户ID/昵称/手机号"
              @keyup.enter.native="search"
              style="margin-left: 10px"
            ></b-form-input>
            <b-button size="sm" variant="primary" @click="search()">
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
          <!-- <div class="header-item-fix">
            <b-form-select
              @change="search()"
              v-model="pageParams.showState"
              class="form-select"
              type="text"
            ></b-form-select>
          </div> -->
          <div class="header-item-fix">
            <span style="line-height: 28px; margin-right: 3px">注册时间:</span>
            <el-date-picker
              style="
                width: fit-content;
                padding: 1px 0px 1px 10px;
                width: 330px;
              "
              @change="getList"
              v-model="registerTime"
              size="mini"
              type="datetimerange"
              range-separator="-"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </div>
        </div>

        <!-- <div style="flex-shrink: 0" id="header-haha"></div> -->
        <!-- <div
          style="
            width: 100%;
            height: 20px;
            'margin-top':5px ;
            'background-color':gray ;
          "
          v-for="(tr, index) in content"
          :key="index"
          id="div-resize"
        ></div> -->
        <div
          :style="{
            'flex-shrink': 1,
            overflow: tableHeadFixed ? 'hidden' : 'auto',
          }"
        >
          <t-table
            size="medium"
            rowKey="id"
            :loading="tableLoading"
            :columns="tableColumns"
            :data="items"
            stripe
            :max-height="screen_height - searchHeight - 230"
            :selected-row-keys="selectedRowKeys"
            @select-change="rehandleSelectChange"
          ></t-table>
        </div>
        <pagination
          :total="pageTotal"
          :pageSize="pageParams.pageSize"
          :page.sync="pageParams.page"
          :pageSizes="[30, 50, 100]"
          @pageCallback="pageCallback"
          ref="page"
          style="flex-shrink: 0; margin-bottom: 0px"
        ></pagination>
      </div>

      <div slot="footer">
        <button
          @click="handleClose()"
          class="btn-sm btn btn-outline-dark"
          type="button"
          style="margin-right: 10px"
        >
          取消
        </button>
        <button @click="save()" class="btn-sm btn btn-primary" type="button">
          确定
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination/pagination.vue";
import api from "@/server/api/user";
export default {
  components: {
    pagination,
  },

  data() {
    return {
      screen_height: 0,
      tableHeadFixed: true, //表头固定
      element: null,
      timer1: 100,
      timer2: 200,
      searchHeight: 51, //表头固定时填入搜索栏高度，如果搜索栏高度是动态变化的就不要固定表头
      showLoading: false,
      pageTotal: 0,
      pageParams: {
        contentKeyword: "",
        pageSize: 30,
        userType: "0",
        page: 1,
      },
      showState: "",
      items: [],
      show: false,
      userTypes: [
        { text: "筛选类型", value: "" },
        // { text: "普通用户", value: "0" },
        { text: "吉视通号", value: 1 },
        { text: "专题/栏目", value: 2 },
        { text: "广电矩阵", value: 3 },
      ],
      content: [],
      tableLoading: false,
      selectedRowKeys: [],
      selectedData: [],
      tableColumns: [
        {
          colKey: "row-select",
          type: "single", //single,multiple
          width: 30,
          fixed: "left",
        },
        {
          colKey: "id",
          title: "ID",
          width: 100,
        },
        {
          colKey: "phone",
          title: "手机",
          width: 110,
          cell: (h, { col, row }) => {
            return row.phone || "--";
          },
        },
        {
          colKey: "nickname",
          title: "昵称",
          minWidth: 200,
          cell: (h, { col, row }) => {
            return row.nickname || "--";
          },
        },
        {
          colKey: "enable",
          title: "状态",
          width: 120,
          cell: (h, { col, row }) => {
            return row.enable ? "正常" : "冻结";
          },
        },
        {
          colKey: "level",
          title: "等级",
          width: 80,
        },
        {
          colKey: "score",
          title: "积分",
          width: 90,
        },
        {
          colKey: "createdAt",
          title: "注册时间",
          width: 170,
        },
      ],
      observer: null,
      sortList: [{ text: "积分", value: "score" }],
      registerTime: [],
      title: "选择用户",
    };
  },

  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "multiple",
    },
  },
  watch: {
    visible(val) {
      this.show = val;
    },
    type(val) {
      if (!val) {
        this.tableColumns[0].type = "multiple";
      } else {
        this.tableColumns[0].type = "single";
      }
    },
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer.takeRecords();
      this.observer = null;
    }
  },
  mounted() {
    window.addEventListener("resize", this.throttle1);
    this.screen_height = window.innerHeight;
    console.log(this.screen_height);
    console.log("加载了");
  },

  methods: {
    showModel(title) {
      if (title) {
        this.title = title;
      }
      this.resetParams();
      this.show = true;
      setTimeout(() => {
        this.element = document.getElementById("div-resize");
        console.log(window.getComputedStyle(this.element).height);
        let MutationObserver =
          window.MutationObserver ||
          window.WebKitMutationObserver ||
          window.MozMutationObserver;
        this.observer = new MutationObserver(() => {
          this.throttle2();
          // this.searchHeight = window.getComputedStyle(this.element).height;
          console.log("检测到变化了", this.searchHeight);
        });
        this.observer.observe(this.element, { childList: true, subtree: true });
      }, 1000);
    },

    handleClose() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer.takeRecords();
        this.observer = null;
      }
      this.show = false;
      this.selectedRowKeys = [];
      this.selectedData = [];
    },
    //获取列表数据
    getList(page) {
      if (typeof page == "number") {
        this.pageParams.page = page;
      }
      let params = this.another(this.pageParams);
      if (Array.isArray(this.registerTime) && this.registerTime[0]) {
        params.registerStartTime = this.registerTime[0];
        params.registerEndTime = this.registerTime[1];
      }
      this.cleanObj(params);
      console.log("搜索参数", params);
      this.tableLoading = true;
      api.list(params).then((resp) => {
        console.log("用户列表", resp.data);
        if (resp.code === 0) {
          this.tableLoading = false;
        }
        if (resp.data) {
          if (resp.data.items) {
            // let ids = [];
            // resp.data.items.map((item) => {
            //   ids.push(item.id);
            // });
            // this.choiceListIds = [];
            // this.allListIds = ids; //当前列表全部id
            this.items = resp.data.items;
            this.pageTotal = resp.data.total;
          }
        }
      });
    },
    // 排序
    listSort(item) {
      if (this.pageParams.orderBy == item.value) {
        this.pageParams.orderBy = item.value;
        if (this.pageParams.sort == "asc") {
          this.pageParams.sort = "desc";
        } else {
          this.pageParams.sort = "asc";
        }
      } else {
        this.pageParams.orderBy = item.value;
        this.pageParams.sort = "asc"; //默认正序
      }
      this.getList();
    },
    save() {
      if (!this.selectedData[0]) {
        this.info("未选择数据");
        return;
      }
      let current = {
        code: "user",
        item: this.selectedData,
      };
      this.handleClose();
      this.$emit("pageCallback", current);
    },
    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.contentKeyword = "";
      this.pageParams.orderBy = "";
      this.pageParams.sort = "";
      this.registerTime = [];
      this.getList();
    },
    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getList();
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
    },
    //显示审核状态
    show_state(state) {
      if (state === 0) {
        return "草稿";
      } else if (state === 1) {
        return "通过";
      } else if (state === 2) {
        return "驳回";
      } else if (state === 3) {
        return "待审核";
      }
    },
    // addContent() {
    //   this.content.push(11111);
    // },
    rehandleSelectChange(value, { selectedRowData }) {
      this.selectedRowKeys = value;
      this.selectedData = selectedRowData;
    },

    throttle1() {
      clearTimeout(this.timer1);
      this.timer1 = setTimeout(() => {
        console.log("调整高度");
        this.screen_height = window.innerHeight;
      }, 500);
    },
    throttle2() {
      clearTimeout(this.timer2);
      this.timer2 = setTimeout(() => {
        console.log("调整搜索栏高度");
        this.searchHeight = window.getComputedStyle(this.element).height;
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-dialog__body {
  padding: 10px 15px 0px;
  background-color: white;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}
::v-deep .el-dialog {
  display: flex !important;
  flex-direction: column !important;
  margin: 0 !important;
  position: relative !important;
  max-height: 95vh !important;
}

::v-deep .table-content-dialog {
  overflow-y: hidden !important;
}

.dialog-common-xb {
  display: flex;
  flex-direction: column;
  max-height: calc(95vh - 141px); //内容高度
  overflow: hidden;
}
::v-deep th {
  padding: 8px 8px 7px 8px;
}
::v-deep td {
  padding: 8px 8px 7px 8px;
}
</style>
